export function PlnIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <mask id="a">
        <circle cx="12" cy="12" r="12" fill="#fff" />
      </mask>
      <g mask="url(#a)">
        <path fill="#d80027" d="M0 12h24v12H0z" />
        <path fill="#ebebeb" d="M0 0h24v12H0z" />
      </g>
    </svg>
  );
}
